<template>
  <transition name="slide-fade">
    <div class="modules">
      <div class="panel">
        <h2 class="lined-heading">
          <span>Track your Symptoms</span>
        </h2>
        <div class="symptoms">
          <router-link
            to="/symptom/sleep"
            class="module"
            @mouseenter.native="playAnimation('sleepAnimation')"
            @mouseleave.native="stopAnimation('sleepAnimation')"
            @focusin.native="playAnimation('sleepAnimation')"
            @focusout.native="stopAnimation('sleepAnimation')"
          >
            <div id="sleep-icon" class="icon"></div>
            <span>Sleep</span>
          </router-link>

          <router-link
            to="/symptom/pain"
            class="module"
            @mouseenter.native="playAnimation('painAnimation')"
            @mouseleave.native="stopAnimation('painAnimation')"
            @focusin.native="playAnimation('painAnimation')"
            @focusout.native="stopAnimation('painAnimation')"
          >
            <div id="pain-icon" class="icon"></div>
            <span>Pain</span>
          </router-link>

          <router-link
            to="/symptom/affect"
            class="module"
            @mouseenter.native="playAnimation('affectAnimation')"
            @mouseleave.native="stopAnimation('affectAnimation')"
            @focusin.native="playAnimation('affectAnimation')"
            @focusout.native="stopAnimation('affectAnimation')"
          >
            <div id="affect-icon" class="icon"></div>
            <span>Mental Health</span>
          </router-link>

          <router-link
            to="/symptom/cognitive-function"
            class="module"
            @mouseenter.native="playAnimation('thoughtAnimation')"
            @mouseleave.native="stopAnimation('thoughtAnimation')"
            @focusin.native="playAnimation('thoughtAnimation')"
            @focusout.native="stopAnimation('thoughtAnimation')"
          >
            <div id="thought-icon" class="icon"></div>
            <span>Cognitive Function</span>
          </router-link>

          <router-link
            to="/symptom/energy-fatigue"
            class="module"
            @mouseenter.native="playAnimation('chargingAnimation')"
            @mouseleave.native="stopAnimation('chargingAnimation')"
            @focusin.native="playAnimation('chargingAnimation')"
            @focusout.native="stopAnimation('chargingAnimation')"
          >
            <div id="charging-icon" class="icon"></div>
            <span>Energy / Fatigue</span>
          </router-link>

          <router-link
            to="/symptom/headache"
            class="module"
            @mouseenter.native="playAnimation('headacheAnimation')"
            @mouseleave.native="stopAnimation('headacheAnimation')"
            @focusin.native="playAnimation('headacheAnimation')"
            @focusout.native="stopAnimation('headacheAnimation')"
          >
            <div id="headache-icon" class="icon"></div>
            <span>Headache</span>
          </router-link>
        </div>
        <h2 class="lined-heading">
          <span>Track your Behaviors</span>
        </h2>
        <div class="behaviors">
          <router-link
            to="/behavior/physical-activity"
            class="module"
            @mouseenter.native="playAnimation('activityAnimation')"
            @mouseleave.native="stopAnimation('activityAnimation')"
            @focusin.native="playAnimation('activityAnimation')"
            @focusout.native="stopAnimation('activityAnimation')"
          >
            <div id="activity-icon" class="icon"></div>
            <span>Physical Activity</span>
          </router-link>

          <router-link
            to="/behavior/pacing"
            class="module"
            @mouseenter.native="playAnimation('pacingAnimation')"
            @mouseleave.native="stopAnimation('pacingAnimation')"
            @focusin.native="playAnimation('pacingAnimation')"
            @focusout.native="stopAnimation('pacingAnimation')"
          >
            <div id="pacing-icon" class="icon"></div>
            <span>Pacing</span>
          </router-link>

          <router-link
            to="/behavior/blood-pressure"
            class="module"
            @mouseenter.native="playAnimation('bloodAnimation')"
            @mouseleave.native="stopAnimation('bloodAnimation')"
            @focusin.native="playAnimation('bloodAnimation')"
            @focusout.native="stopAnimation('bloodAnimation')"
          >
            <div id="blood-icon" class="icon"></div>
            <span>Blood Pressure</span>
          </router-link>

          <router-link
            to="/worksheets"
            class="module"
            @mouseenter.native="playAnimation('worksheetAnimation')"
            @mouseleave.native="stopAnimation('worksheetAnimation')"
            @focusin.native="playAnimation('worksheetAnimation')"
            @focusout.native="stopAnimation('worksheetAnimation')"
          >
            <div id="worksheet-icon" class="icon"></div>
            <span>Worksheets</span>
          </router-link>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapMutations } from "vuex";
import lottie from "lottie-web";

export default {
  name: "dashboard",
  methods: {
    ...mapMutations([
      "modifyLoggedIn",
      "changePageTitle",
      "changePageIntroText",
    ]),

    playAnimation(animation) {
      this.animations[animation].play();
    },

    stopAnimation(animation) {
      this.animations[animation].stop();
    },
  },
  data() {
    return {
      animations: {},
    };
  },
  mounted() {
    // Set login to true.
    this.modifyLoggedIn(true);

    // Set the page title.
    this.changePageTitle("Welcome");

    // Set page text.
    this.changePageIntroText();

    const icons = [
      "activity",
      "affect",
      "charging",
      "pacing",
      "pain",
      "sleep",
      "thought",
      "worksheet",
      "blood",
      "headache",
    ];

    for (const icon of icons) {
      this.animations[`${icon}Animation`] = lottie.loadAnimation({
        container: document.getElementById(`${icon}-icon`),
        rendered: "svg",
        autoplay: false,
        path: `/app/animation/${icon}.json`,
      });
    }
  },
};
</script>

<style scoped>
.lined-heading {
  font-family: BebasNeue, serif;
  font-size: 1.5rem;
  font-weight: 400;
  position: relative;
  text-align: center;
}

.lined-heading span {
  background-color: var(--white);
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  position: relative;
  z-index: 1;
}

.lined-heading::after {
  bottom: 50%;
  content: "";
  border-bottom: 1px solid var(--grey);
  display: block;
  position: absolute;
  width: 100%;
}

.panel {
  padding: 1rem 2rem;
}

.module {
  color: var(--dark);
  display: flex;
  flex-direction: column;
  font-size: 1.125rem;
  font-weight: 600;
  text-decoration: none;
  flex-basis: 33%;
  padding: 2rem;
  text-align: center;
}

.module-icon {
  margin-bottom: 1rem;
}

.icon {
  margin: 0 auto;
  max-width: 130px;
}

.symptoms,
.behaviors {
  display: flex;
  flex-wrap: wrap;
}

.behaviors {
  justify-content: center;
}

.modules {
  padding-bottom: 5rem;
}

@media all and (max-width: 640px) {
  .module {
    flex-basis: 50%;
  }
}

@media all and (max-width: 400px) {
  .module {
    flex-basis: 100%;
  }
}
</style>
